import type { Contract } from "./contract";
import type { Courier, CourierOffice } from "./courier";

export interface Order {
	createdAt: string;
	updatedAt: string;
	deletedAt: null | string;
	id: string;
	paymentRef: string;
	orderAmount: string;
	contractId: string;
	customerId: string;
	courierId: null | string;
	estimatedCourierFee?: number;
	transactionFee?: number;
	actualCourierFee?: number;
	trackingNumber: null | string;
	paymentOption: string;
	status: OrderStatusEnum;
	dispatchStatus: DispatchStatusEnum;
	approvalStatus: "COMPLETED" | "PENDING" | "DISPUTED";
	contract: Contract;
	pickupLocation: CourierOffice;
	dropoffLocation: CourierOffice | null;
	trackings: any[];
	__type: "Order";
	pickupCourier: Courier;
	dropoffCourier: Courier;
}

export enum OrderStatusEnum {
	COMPLETED = "COMPLETED",
	PENDING = "PENDING",
	PAID = "PAID",
	CANCELED = "CANCELED",
	EXPIRED = "EXPIRED",
	FAILED = "FAILED",
	REJECTED = "REJECTED"
}

export enum DispatchStatusEnum {
	Pending = "Pending",
	Dispatch = "Dispatch",
	InTransit = "InTransit",
	Arrived = "Arrived",
	Delivered = "Delivered"
}

export const DispatchStatusDisplayText: Record<DispatchStatusEnum, string> = {
	[DispatchStatusEnum.Pending]: "Your order is being prepared.",
	[DispatchStatusEnum.Dispatch]: "Your order is on its way to the courier.",
	[DispatchStatusEnum.InTransit]: "Your order is in transit.",
	[DispatchStatusEnum.Arrived]: "Your order has arrived at the delivery hub.",
	[DispatchStatusEnum.Delivered]: "Your order has been successfully delivered."
};
